import React from "react"
import { Redirect } from "react-router-dom"

import { SsoMode } from "@cirrus/common/CustomerInfo"

import { ResetPasswordScreenContent } from "./ScreenContent"
import { useCustomerInfo } from "../../../CustomerInfo"

export const ResetPasswordProtectedScreenContent = () => {
  const { data } = useCustomerInfo()
  const allowed = data?.saml?.ssoMode !== SsoMode.Enforced
  return allowed ? <ResetPasswordScreenContent/> : <Redirect to="/"/>
}
